import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import { GenericAnalyticsClient } from './client';
export var AnalyticsClientContext = /*#__PURE__*/React.createContext({});
export var AnalyticsClientProvider = function AnalyticsClientProvider(_ref) {
  var children = _ref.children,
      rudderStack = _ref.rudderStack;
  var analytics = new GenericAnalyticsClient({
    rudderStack: rudderStack
  });

  if (rudderStack === null || rudderStack === void 0 ? void 0 : rudderStack.customClient) {
    analytics = rudderStack === null || rudderStack === void 0 ? void 0 : rudderStack.customClient(rudderStack);
  }

  return /*#__PURE__*/React.createElement(AnalyticsClientContext.Provider, {
    value: analytics
  }, children);
};
export var withAnalyticsClient = function withAnalyticsClient(Component) {
  return function (_ref2) {
    var props = _extends({}, _ref2);

    return /*#__PURE__*/React.createElement(AnalyticsClientContext.Consumer, null, function (analytics) {
      return /*#__PURE__*/React.createElement(Component, _extends({
        analytics: analytics
      }, props));
    });
  };
};
export var useAnalyticsClient = function useAnalyticsClient() {
  return useContext(AnalyticsClientContext);
};
export { GenericAnalyticsClient };